import React from 'react';
import AutoComplete from 'material-ui/AutoComplete';
import { capitalize } from 'lodash';
import { MenuItem, RaisedButton, TextField } from 'material-ui';
import _ from 'lodash';


import api from 'services';
import PropTypes from 'prop-types';

class PodPor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ports: [],
        };

        this.dAutocomplete = _.debounce((searchText) => {
            if (searchText.length < 2) {
                return;
            }

            api.findPortAdmin({ name: searchText, withAreas: true })
                .then((response) => {
                    const ports = [];

                    response.data.data.forEach((port) => {
                        ports.push(...this.createPort(port));
                    });

                    this.setState({
                        ports,
                    });
                })
                .catch(() => null);
        }, 500);
    }

    createPort(port) {
        const ports = [];
        let name = '';

        if (port.sub) {
            port.sub.forEach((subPort) => {
                ports.push({
                    item: subPort,
                    text: `${subPort.name} - country ${port.country.name}`,
                    _id: port._id,
                    value: (
                        <MenuItem
                            primaryText={`${subPort.name} - country ${port.country.name}`}
                            value={subPort}
                            style={{ paddingLeft: '30px' }}
                        />
                    ),
                });
            });
        }

        if (port.country) {
            name = `${port.name} - country ${port.country.name}`;
        } else {
            name = port.name;
        }

        return [
            {
                _id: port._id,
                text: name,
                item: port,
                value: (
                    <MenuItem
                        primaryText={name}
                        value={port}
                    />
                ),
            },
            ...ports,
        ];
    }

    changeAutoComplete = (searchText) => {
        const port = _.cloneDeep(this.props.port);
        port.port.name = searchText;
        if (!searchText) {
            delete port.port._id;
        }
        this.props.changePortData(
            this.props.portIndex,
            this.props.portType,
            port,
        );

        this.dAutocomplete(searchText);
    }

    chooseAutoComplete = (port) => {
        if (!port) {
            return;
        }

        this.props.changePortData(
            this.props.portIndex,
            this.props.portType,
            {
                ...this.props.port,
                port: port.item,
            },
        );
    }

    getDefaultPort = () => ({
        port: {
            _id: null,
            name: null,
        },
        details: null,
        main: false,
    })

    changeDetails = (_e, value) => {
        const port = _.cloneDeep(this.props.port);
        port.details = value;
        this.props.changePortData(
            this.props.portIndex,
            this.props.portType,
            port,
        );
    }

    render() {
        const {
            portType, portIndex, removePort, port, 
        } = this.props;
        const { ports } = this.state;

        const label = `${capitalize(portType)} port${portIndex === 0 && portType === 'delivery' ? '*' : ''}`;

        return (
            <React.Fragment>
                <div className="row" style={{ display: 'flex' }}>
                    <AutoComplete
                        floatingLabelText={label}
                        textFieldStyle={{ fontSize: '13px' }}
                        hintText={label}
                        searchText={port.port.name || ''}
                        dataSource={ports}
                        onUpdateInput={this.changeAutoComplete}
                        onNewRequest={this.chooseAutoComplete}
                        // dataSourceConfig={{ text: 'name', value: '_id' }}
                        required={portIndex === 0}
                        filter={AutoComplete.noFilter}
                        listStyle={{ overflow: 'auto', maxHeight: '300px', width: 'auto' }}
                        menuStyle={{ width: 'auto' }}
                        popoverProps={{
                            canAutoPosition: true,
                        }}
                        style={{ marginLeft: '10px' }}
                    />

                    <TextField
                        floatingLabelText='Details'
                        style={{ fontSize: '13px', marginLeft: '15px', width: 'auto' }}
                        value={port.details || ''}
                        onChange={this.changeDetails}
                        fullWidth
                    />
                    
                    {
                        this.props.portIndex !== 0 &&
                            <React.Fragment>
                                <RaisedButton 
                                    label="Remove Port"
                                    secondary
                                    style={{ margin: '35px 0 0 15px', height: '25px' }}
                                    buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                    labelStyle={{ fontSize: '13px' }}
                                    onClick={() => { removePort(portIndex, portType); }}
                                />
                            </React.Fragment>
                    }
                </div>
            </React.Fragment>
        );
    }
}

PodPor.propTypes = {
    portIndex: PropTypes.number,
    portType: PropTypes.oneOf(['delivery', 'redelivery']),
    port: PropTypes.object,
    removePort: PropTypes.func,
    changePortData: PropTypes.func,
};

export default PodPor;



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/TC/content/podPor/PodPor.jsx